import { SharedModule } from '@/app/shared/shared.module';
import { Component, inject, Input } from '@angular/core';
import { DynamicDialogRef } from 'primeng/dynamicdialog';

@Component({
  selector: 'app-activity-delete-confirm-modal',
  imports: [SharedModule],
  templateUrl: './activity-delete-confirm-modal.component.html',
  styleUrl: './activity-delete-confirm-modal.component.less'
})
export class ActivityDeleteConfirmModalComponent {
  private _dynamicDialogRef = inject(DynamicDialogRef);
  @Input() icon = 'ph-fill ph-trash';
  @Input() title: string;
  @Input() description: string;
  @Input() confirmBtnLabel: string;
  @Input() cancelBtnLabel: string;

  close(submit = false) {
    this._dynamicDialogRef.close(submit);
  }
}
